import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    padding: theme.spacings.md,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  depList: {
    marginTop: theme.spacings.sm,
  },
  slateText: {
    fontSize: theme.fontSizes.lg,
    color: theme.colors.black,
  },
});
